<div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <div class="icon-container">
          <i class="fa fa-user-plus" aria-hidden="true"></i>
        </div>
        <div class="header-text">
        <h2 style="font-weight: 600" *ngIf="data?.contact">Edit Contact</h2>
        <h2 style="font-weight: 600" *ngIf="!data?.contact">Add Contact</h2>
        
          <p>Save your contacts for future reference.</p>
        </div>
      </div>
      <img class="close-button" (click)="onCancel()" src="assets/images/close-circle.svg" alt="Close" />
    </div>
  
    <div class="dialog-content">
        <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
      
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" maxlength="30" (input)="0" />
            <!-- Character counter -->
            <mat-hint align="end">
              {{ f.name.value?.length || 0 }}/30
            </mat-hint>
  
            <mat-error *ngIf="submitted && f.name.errors?.required">This field is required</mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email Address</mat-label>
            <input matInput formControlName="email" />
            <mat-error *ngIf="submitted && f.email.errors?.required">This field is required</mat-error>
            <!-- <mat-error *ngIf="submitted && f.email.errors?.email">Please enter a valid email address</mat-error> -->
            <mat-error *ngIf="f.email.touched && f.email.errors?.email">Please enter a valid email address</mat-error>

          </mat-form-field>
      
          <mat-form-field appearance="fill">
            <mat-label>Select Folder</mat-label>
            <mat-select  formControlName="category">
              <mat-option *ngFor="let category of Categories" [value]="category.title">
                {{ category.title }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Address</mat-label>
            <textarea matInput formControlName="address" placeholder="Address" maxlength="500" (input)="0" ></textarea>
            <!-- Character counter -->
            <mat-hint align="end">
              {{ f.address.value?.length || 0 }}/500
            </mat-hint>
          </mat-form-field>
      
          <!-- <mat-form-field appearance="fill">
            <mat-label>Select Country Affiliation</mat-label>
            <mat-select  formControlName="affiliation_type">
              <mat-option *ngFor="let affiliation of Affiliations" [value]="affiliation.id">
                {{ affiliation.title }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->

          <mat-form-field appearance="outline" style="width: 100%;" class="custom-country-select">
            <mat-label>Select Country Affiliation</mat-label>

            <mat-select formControlName="affiliation_type" placeholder="Select Country Affiliation">
              <!-- 👇 Correct trigger -->
              <mat-select-trigger>
                <ng-container *ngIf="myForm.get('affiliation_type')?.value as selectedCountry">
                  <img [src]="'https://flagcdn.com/w20/' + (countryObj[selectedCountry]?.toLowerCase() || '') + '.png'" width="20"
                    height="15" style="vertical-align: middle; margin-right: 8px;" alt="{{ selectedCountry }} flag" />
                  {{ selectedCountry }}
                </ng-container>
              </mat-select-trigger>

              <!-- Dropdown options -->
              <mat-option *ngFor="let country of Affiliations" [value]="country[0]">
                <img [src]="'https://flagcdn.com/w20/' + country[1].toLowerCase() + '.png'" width="20" height="15"
                  style="vertical-align: middle; margin-right: 8px;" alt="{{ country[0] }} flag" />
                {{ country[0] }}
              </mat-option>
            </mat-select>
          </mat-form-field>

      
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Other Details</mat-label>
            <textarea matInput formControlName="notes" placeholder="Other Details" maxlength="500" (input)="0" ></textarea>
            <!-- Character counter -->
            <mat-hint align="end">
              {{ f.notes.value?.length || 0 }}/500
            </mat-hint>
          </mat-form-field>
      
          <div class="button-group">
            <button mat-button type="button" class="btn-secondary" (click)="onCancel()">Cancel</button>
            <button mat-raised-button color="primary" class="btn-primary" type="submit"
             [ngClass]="{'btn-disabled': !myForm.valid}" [disabled]="!myForm.valid">Save</button>
          </div>
      
        </form>
    </div>
      
  </div>
  